import { CLEAR_TILTED_ROOF, SET_TILTED_ROOF, SET_TILTED_ROOF_STRUCTURE_TILT } from 'actions';
import { dispatch, state } from '__common/store';
import { getNewRoofId } from '../../../googleMapsRoofsSelector/components/drawingManager/drawingManagerHelper';
import { isASCE716BuildingCode, isASCE716or722BuildingCode, isFlatRoof } from 'projectDesign/components/projectConfiguration/projectConfiguration';
import {
  isCommercialProduct,
  products,
  isRMIFIProduct,
  isEcoFoot2Plus,
  isSMTiltPR,
  isRM5,
  isRM10orRM10Evo,
  isRmGridflex10D,
  isRmGridflex5Rwdi,
  isSolarMount,
  isNxtHorizon,
  isSMFlushOrTiltOrTiltPR,
} from '__common/constants/products';
import { greaterThanEqualToProjectVersion } from '__common/utils/versionCompare/versionCompare';
import { VERSION_MAP } from '__common/utils/versionCompare/version_info';
const PROJECTS_WITH_ROOF_PITCH = [products.sunframe, products.solarmount_2, products.sfmEnhanced, products.sfmInfinity, products.metal_x, products.rm_gridflex,products.nxt_umount, products.solarmount_2_tilt, products.nxt_tilt];

export const ROOF_PITCH: { [key: string]: number } = {
  ['1/12']: 5,
  ['2/12']: 9,
  ['3/12']: 14,
  ['4/12']: 18,
  ['5/12']: 23,
  ['6/12']: 27,
  ['7/12']: 30,
  ['8/12']: 34,
  ['9/12']: 37,
  ['10/12']: 40,
  ['11/12']: 43,
  ['12/12']: 45,
};
export {
  ROOF_PITCH_GRIDFLEX,
  ROOF_PITCH_DEGREES,
  getScaleFromPitchRoof,
} from '__editor/panelsEditor/geometry/setbackGeometry';

export const loadRoofPitch = () => {
  const { app: { isUbuilderLite }, projectConfiguration: { productId, projectEnvConfig: { building_code, building_type } } } = state();
  const { background: { selectedRoofId }, drawingManager: { roofs } } = state();
  // Defensive: lite + satellite paths can leave selectedRoofId pointing at a
  // roof id that's not in the loaded roofs (e.g., advanceToSeeding hard-codes
  // 0 but server roofs are id=1+ from satellite). Without this guard the
  // PanelsEditor crashes on bootstrap and React's error boundary loops.
  if (roofs && roofs[selectedRoofId]) {
    const roofPitch = roofs[selectedRoofId].roofPitch;
    if (roofPitch) {
      dispatch(SET_TILTED_ROOF(roofPitch));
      return;
    }
  }

  if (isUbuilderLite) {
    const lastPitch = getLastRoofPitch();
    if (lastPitch && lastPitch !== '---') {
      dispatch(SET_TILTED_ROOF(lastPitch));
      return;
    }
  }

  dispatch(CLEAR_TILTED_ROOF(productId, building_code, building_type));
};

export const loadStructureTilt = () => {
  const { background: { selectedRoofId }, drawingManager: { roofs } } = state();
  if (!roofs || !roofs[selectedRoofId]) return;
  const structureTilt = roofs[selectedRoofId].structureTilt;
  if (structureTilt || structureTilt === 0) {
    dispatch(SET_TILTED_ROOF_STRUCTURE_TILT(String(structureTilt)));
  }
};

export const getLastRoofPitch = () => {
  const { drawingManager: { roofs }, tiltedRoof } = state();

  if (roofs && Object.keys(roofs).length) {
    const lastRoof = roofs[Number(getNewRoofId()) - 1];
    if (lastRoof) {
      return lastRoof.roofPitch;
    }
  }

  return tiltedRoof && tiltedRoof.roofPitch;
};

export const getDefaultRoofPitchValue = (productId: number, buildingCode: number, buildingType: number) => {
  const { app: { isUbuilderLite }, projectConfiguration : {projectVersion} } = state();
  const isProjectWithRoofPitch = isUbuilderLite
    ? (isSMFlushOrTiltOrTiltPR(productId) || isNxtHorizon(productId))
    : PROJECTS_WITH_ROOF_PITCH.includes(productId);
  const nonRoofPitch = null;
  let defaultRoofPitch = isSMTiltPR(productId) ? null : '---' ;
  if (isUbuilderLite && (isSMFlushOrTiltOrTiltPR(productId) || isNxtHorizon(productId))) {
    defaultRoofPitch = '14';
  }
  const defaultRoofPitchForGridflex = '---';
  const defaultRoofPitchForEcoFoot2Plus = '---';
  const defaultRoofPitchForRM = greaterThanEqualToProjectVersion(projectVersion, VERSION_MAP['default_roofpitch_value_changes']) ? '1' : '0';
  if (isRMIFIProduct(productId)) {
    return defaultRoofPitchForGridflex;
  }

  if(isRM5(productId) || isRM10orRM10Evo(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)){
    return defaultRoofPitchForRM;
  }
  
  if(isEcoFoot2Plus(productId)) {
    return defaultRoofPitchForEcoFoot2Plus;
  }

  if (isCommercialProduct(productId) || !isProjectWithRoofPitch) {
    return nonRoofPitch;
  }

  if (!isASCE716or722BuildingCode(buildingCode) && isProjectWithRoofPitch) {
    return defaultRoofPitch;
  }

  if (isASCE716or722BuildingCode(buildingCode) && !isFlatRoof(buildingType) && isProjectWithRoofPitch) {
    return defaultRoofPitch;
  }

  if (isASCE716or722BuildingCode(buildingCode) && isFlatRoof(buildingType)) {
    return nonRoofPitch;
  }
};
